export const enum ResourceModalType {
  new = 'new',
  edit = 'edit',
  delete = 'delete',
}

export const enum FolderModalType {
  new = 'new',
  edit = 'edit',
  delete = 'delete',
}

export const enum CourseClassMode {
  none,
  detail,
  new,
  edit,
}
